
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationNewFolderCreate: {
    id: "ConfigurationNewFolder.create",
    defaultMessage: "Create",
  }, 
  configurationNewFolderCancel: {
    id: "ConfigurationNewFolder.cancel",
    defaultMessage: "Cancel",
  }, 
  configurationNewFolderHeading: {
    id: "ConfigurationNewFolder.newHeading",
    defaultMessage: "New Folder",
  },
  configurationNewFolderNestedHeading: {
    id: "ConfigurationNewFolderNested.newHeading",
    defaultMessage: "New Construction Phase",
  },
  configurationNewBuildingNumber: {
    id: "BuildingNumber.number",
    defaultMessage: "Building Number",
  },
  configurationNewOpportunityNumber: {
    id: "OpportunityNumber.number",
    defaultMessage: "Opportunity Number",
  },
  configurationNewFolderName: {
    id: "FolderName.name",
    defaultMessage: "Folder Name",
  }
});

export default MESSAGES;